export const initialFilterState = {
  selectedTenant: [],
  selectedDepartment: [],
  selectedStatus: undefined,
  paymentStatus: [],
  apinvoiceFromDueDate: null,
  apinvoiceToDueDate: null,
  selectedTag: [],
};

export function filterReducer(state, action) {
  switch (action.type) {
    case "SET_TENANT":
      return { ...state, selectedTenant: action.payload };
    case "SET_DEPARTMENT":
      return { ...state, selectedDepartment: action.payload };
    case "SET_STATUS":
      return { ...state, selectedStatus: action.payload };
    case "SET_PAYMENT_STATUS":
      return { ...state, paymentStatus: action.payload };
    case "SET_TAG":
      return { ...state, selectedTag: action.payload };
    case "UPDATE_URL": {
      return {
        ...state,
        selectedTenant: action.payload.selectedTenant,
        selectedDepartment: action.payload.selectedDepartment,
        selectedStatus: action.payload.selectedStatus,
        paymentStatus: action.payload.paymentStatus,
        selectedTag: action.payload.selectedTag,
      };
    }
    case "RESET":
      return initialFilterState;
    default:
      return state;
  }
}
